// dependancys
import React, { lazy } from "react";
import PropTypes from "prop-types";
import { Route } from "react-router-dom";

// lazy load components
const EditProfile = lazy(() => import("../_pages/_profile/_sections/_profileInfo/editProfile/EditProfile"));
const EditBusiness = lazy(() => import("../_pages/_profile/_sections/_profileInfo/editBusiness/editBusiness"));
const EditPassword = lazy(() => import("../_pages/_profile/_sections/_profileInfo/editPassword/EditPassword"));
const EditAddressFields = lazy(() => import("../_pages/_addresses/editAddressFields/EditAddressFields"));
const AddNewAddress = lazy(() => import("../_pages/_addresses/addNewAddress/AddNewAddress"));
const AddNewContact = lazy(() => import("../_pages/_addresses/addNewContact/AddNewContact"));
const EditContact = lazy(() => import("../_pages/_addresses/editContact/EditContact"));
const EditSecondaryAddress = lazy(() => import("../_pages/_addresses/editAddressFields/EditSecondaryAddress"));

const CustomRoutes = ({ history }) => {
    // urls
    const profileUrl = "/Profile";
    const addressesUrl = "/Addresses";

    // margin styling
    const marginBottom = { marginBottom: "2.6rem" };

    return (
        <>
            {/** Edit Screens */}
            <div className="grid-container" style={marginBottom}>
                {/** PROFILE */}
                {/** Edit Profile */}
                <Route exact path="/Profile/edit-profile" component={() => <EditProfile history={history} returnUrl={profileUrl} />} />

                {/** Edit Business */}
                <Route exact path="/Profile/edit-business" component={() => <EditBusiness history={history} returnUrl={profileUrl} />} />

                {/** Edit Password */}
                <Route exact path="/Profile/edit-password" component={() => <EditPassword history={history} returnUrl={profileUrl} />} />

                {/** ADDRESSES */}
                {/** Add New Address */}
                <Route exact path="/Addresses/add-new-address" component={() => <AddNewAddress history={history} returnUrl={addressesUrl} />} />

                {/** Edit Address */}
                <Route exact path="/Addresses/edit-address" component={() => <EditAddressFields history={history} returnUrl={addressesUrl} />} />

                {/** Edit Secondary Address */}
                <Route exact path="/Addresses/edit-secondary-address" component={() => <EditSecondaryAddress history={history} returnUrl={addressesUrl} />} />

                {/** Add New Contact */}
                <Route exact path="/Addresses/add-new-contact" component={() => <AddNewContact history={history} returnUrl={addressesUrl} />} />

                {/** Add New Contact */}
                <Route exact path="/Addresses/edit-contact" component={() => <EditContact history={history} returnUrl={addressesUrl} />} />
            </div>
        </>
    );
};

export default CustomRoutes;

// props validation
CustomRoutes.propTypes = {
    history: PropTypes.object
};
